export default __webpack_public_path__ + "assets/images/bg_mobile2.png";